<template>
  <basic-input-modal
    @selectedElement="propagateChange"
    :byDefault="getData()"
    :student="studentName"
    :title="title"
    ref="input"
    :options="items"/>
</template>
<script>
import BasicInputModal from './BasicInputModal.vue'
import {componentValues, getDataByValue} from '@/utils/componentsValue'

export default {
  components: { BasicInputModal },
  created: function () {
    if (this.$attrs.student) this.state = this.$attrs.student.nap
  },
  props: {
    title: {
      type: String,
      default: () => 'Siesta'
    },
    studentName: String
  },
  data: () => ({
    enabled: true,
    byDefault: 'ausente',
    state: '',
    items: componentValues.nap
  }),
  methods: {
    getData: function () {
      return getDataByValue(this.items, this.state)
    },
    setValue: function (value) {
      this.state = value
      this.$refs.input.setValue(this.getData())
    },
    setEnable: function (value) {
      this.enabled = value
      this.$refs.input.setEnable(value)
      this.enabled ? this.setValue(this.byDefault) : this.setValue('ausente')
    },
    propagateChange: function ({item}) {
      this.$emit('updatedElement',
        { nap: item.value }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/Nap.vue